import { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function PaymentDetail(props) {
  const { isSmall } = useBreakpoints();

  return (
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
      <Box gridColumn={isSmall ? "span 12" : "span 5"}>
        <Autocomplete
          size="small"
          value={props.state?.paymentType ? props.state.paymentType : ""}
          onChange={(event, newValue) => {
            if (newValue) {
              props.setState({
                ...props.state,
                paymentType: newValue,
              });
            } else {
              props.setState({
                ...props.state,
                paymentType: "",
              });
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return value == "" || option === value;
          }}
          getOptionDisabled={(option) =>
            props.paymentType.find((m) => m.id == option)?.enable == false
          }
          getOptionLabel={(option) => {
            if (option) {
              return props.paymentType !== undefined &&
                props.paymentType.find((m) => m.id == option)
                ? props.paymentType.find((m) => m.id == option)?.title
                : "";
            }
            return "";
          }}
          fullWidth
          options={
            props.paymentType && props.paymentType.length > 0
              ? props.paymentType.map((m) => m.id)
              : []
          }
          renderInput={(params) => (
            <TextField
              error={props.errorState?.paymentType}
              variant="outlined"
              {...params}
              label="نوع پرداخت"
            />
          )}
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 5"}>
        <TextField
          fullWidth
          id="outlined-basic"
          value={props.state?.offlinePayCode ? props.state.offlinePayCode : ""}
          label="شناسه پرداخت"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            props.setState({
              ...props.state,
              offlinePayCode: evt.target.value,
            });
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 2"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 5"}>
        <TextField
          fullWidth
          id="outlined-basic"
          label={`هدیه ${
            props.row && props.row.gift
              ? ":" + props.row.gift.giftName
              : " : نامشخص"
          } `}
          size="small"
          sx={{
            "& .MuiInputLabel-root": {
              color: "#646464",
            },
            input: {
              py: 1.2,
            },
          }}
          InputLabelProps={{
            shrink: false,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
          onChange={(evt) => {
            props.setState({ ...props.state, website: evt.target.value });
          }}
        />
      </Box>
      <Box gridColumn="span 12">
        <FormGroup sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={props.state?.notUsecraditDiscount}
                onChange={(event) =>
                  props.setState({
                    ...props.state,
                    notUsecraditDiscount: event.target.checked,
                  })
                }
                sx={{ pr: 0 }}
              />
            }
            label="تخفیف اعتباری لحاظ نگردد"
            sx={{ width: isSmall ? "100%" : isSmall ? "100%" : "40%" }}
          />
          <FormControlLabel
            control={
              <Checkbox
                sx={{ pr: 0 }}
                checked={props.state?.Confidential}
                onChange={(event) =>
                  props.setState({
                    ...props.state,
                    Confidential: event.target.checked,
                  })
                }
              />
            }
            label="سفارش به صورت محرمانه ارسال شود"
          />
          <FormControlLabel
            sx={{ width: isSmall ? "100%" : "40%" }}
            control={
              <Checkbox
                sx={{ pr: 0 }}
                checked={props.state?.SendFactor}
                onChange={(event) =>
                  props.setState({
                    ...props.state,
                    SendFactor: event.target.checked,
                  })
                }
              />
            }
            label="فاکتور ارسال نشود"
          />
          <FormControlLabel
            control={
              <Checkbox
                sx={{ pr: 0 }}
                checked={props.state?.SendSMS}
                onChange={(event) =>
                  props.setState({
                    ...props.state,
                    SendSMS: event.target.checked,
                  })
                }
              />
            }
            label="اس‌ام‌اس ارسال نشود"
          />
        </FormGroup>
      </Box>
    </Box>
  );
}
